import { Zodios } from "@zodios/axios";
import type { ZodiosEndpointDefinition } from "@zodios/core";
import { ZodiosHooks } from "@zodios/react";
import axios from "axios";
import { env } from "config/env";

export const makeClientWithHooks = <Api extends ReadonlyArray<ZodiosEndpointDefinition>>(name: string, api: Api) => {
  const client = new Zodios(`${env.REACT_APP_SG_API_URL}api`, api, { axiosInstance: axios });
  return { client, hooks: new ZodiosHooks(name, client) };
};
